import { api } from "@/redux/api";

import { FeaturesResponse, FeaturesResponseSchema } from "../../pages/Users/schema/feature";

export const featureApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getFeatures: builder.query<FeaturesResponse, void>({
			query: () => ({
				url: "features",
				responseSchema: FeaturesResponseSchema,
			}),
			providesTags: ["Features"],
		}),
		getUnauthenticatedFeatures: builder.query<FeaturesResponse, void>({
			query: () => ({
				url: "features/UNAUTHENTICATED",
				responseSchema: FeaturesResponseSchema,
			}),
			providesTags: ["Features"],
		}),
	}),
});

export const { useGetFeaturesQuery, useGetUnauthenticatedFeaturesQuery } = featureApi;
export const accountApiReducer = featureApi.reducer;
export const accountApiMiddleware = featureApi.middleware;
